import React from "react";
import {
  getIntegrationCategoryList,
  lucideIconForAPICategory,
  categoryDisplayName,
} from "../../../../models/Helpers";
import {
  CONFIGURATION_INTEGRATIONS_ENDPOINT_USAGE_PATH,
  CONFIGURATION_INTEGRATIONS_PATH,
  getIntegrationConfigurationPathForIndividualCategory,
} from "../../../../router/RouterUtils";
import SubLeftNavigationContainer from "../../../portal/SubLeftNavigationContainer";
import PortalPageHeaderWrapper from "../../../portal/PortalPageHeaderWrapper";
import useAppContext from "../../../context/useAppContext";
import { APICategory } from "../../../../models/Entities";

type ConfigurationIntegrationsPageWrapperProps = {
  children: JSX.Element | JSX.Element[];
  isEndpointUsageEnabled?: boolean;
};

function ConfigurationIntegrationsPageWrapper({
  children,
  isEndpointUsageEnabled,
}: ConfigurationIntegrationsPageWrapperProps) {
  const { user } = useAppContext();
  return (
    <PortalPageHeaderWrapper
      title="Integrations"
      {...(isEndpointUsageEnabled && {
        subtabs: [
          { label: "Overview", destination: CONFIGURATION_INTEGRATIONS_PATH },
          { label: "Endpoint usage", destination: CONFIGURATION_INTEGRATIONS_ENDPOINT_USAGE_PATH },
        ],
      })}
      subtitle="Manage the integrations you make available to your users"
    >
      <SubLeftNavigationContainer
        subtabs={getIntegrationCategoryList(user).map((category: APICategory) => ({
          label: categoryDisplayName(category),
          destination: getIntegrationConfigurationPathForIndividualCategory(category),
          icon: lucideIconForAPICategory(category, "md", "mr-3"),
        }))}
      >
        {children}
      </SubLeftNavigationContainer>
    </PortalPageHeaderWrapper>
  );
}

export default ConfigurationIntegrationsPageWrapper;
